
namespace RioERP.Invoices {

    @Serenity.Decorators.registerClass()
    export class OrderSourcesDialog extends Serenity.EntityDialog<OrderSourcesRow, any> {
        protected getFormKey() { return OrderSourcesForm.formKey; }
        protected getIdProperty() { return OrderSourcesRow.idProperty; }
        protected getLocalTextPrefix() { return OrderSourcesRow.localTextPrefix; }
        protected getNameProperty() { return OrderSourcesRow.nameProperty; }
        protected getService() { return OrderSourcesService.baseUrl; }
        protected getDeletePermission() { return OrderSourcesRow.deletePermission; }
        protected getInsertPermission() { return OrderSourcesRow.insertPermission; }
        protected getUpdatePermission() { return OrderSourcesRow.updatePermission; }

        protected form = new OrderSourcesForm(this.idPrefix);

    }
}